var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChattingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3384 15C21.3384 15.5304 21.1277 16.0391 20.7527 16.4142C20.3776 16.7893 19.8689 17 19.3384 17H7.33844L3.33844 21V5C3.33844 4.46957 3.54915 3.96086 3.92423 3.58579C4.2993 3.21071 4.80801 3 5.33844 3H19.3384C19.8689 3 20.3776 3.21071 20.7527 3.58579C21.1277 3.96086 21.3384 4.46957 21.3384 5V15Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChattingIcon);
export default __webpack_public_path__ + "static/media/chatting_icon.38d39fc0759b727ca679fa9d126b6fce.svg";
export { ForwardRef as ReactComponent };